export enum GroupStatus {
  ACTIVE = 'ACTIVE',
  MINOR_UPDATE_WITH_AUTO_MAPPING_SLIDES = 'MINOR_UPDATE_WITH_AUTO_MAPPING_SLIDES',
  MAJOR_UPDATE = 'MAJOR_UPDATE',
  ARCHIVED = 'ARCHIVED',
  REVOKED = 'REVOKED',
  DELETED = 'DELETED',
}
